import React, { useState, useEffect } from 'react';
import './HeroSection.css';

const BASE = process.env.PUBLIC_URL || '';

const SLIDES = [
  {
    img: `${BASE}/images/hero%20banner%201.png`,
    heading: 'Thoughtful Gifts',
    sub: 'Stronger Business Bonds',
    align: 'left',
  },
  {
    img: `${BASE}/images/hero%20banner%202.png`,
    heading: 'Celebrate Every Milestone',
    sub: 'Make Your Team Feel Valued',
    align: 'left',
  },
  {
    img: `${BASE}/images/hero%20banner%203.png`,
    heading: 'Premium Corporate Gifting',
    sub: 'Curated for Every Occasion',
    align: 'left',
  },
  {
    img: `${BASE}/images/hero%20banner%204.png`,
    heading: 'Gifts Worth Remembering',
    sub: 'Turn Every Gift Into Brand Value',
    align: 'left',
  },
];

const INTERVAL = 4000;

function HeroSection() {
  const [current, setCurrent] = useState(0);
  const touchStartX = React.useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % SLIDES.length);
    }, INTERVAL);
    return () => clearInterval(timer);
  }, []);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setCurrent(prev => (prev + 1) % SLIDES.length);
      else setCurrent(prev => (prev - 1 + SLIDES.length) % SLIDES.length);
    }
    touchStartX.current = null;
  };

  const slide = SLIDES[current];

  return (
    <section id="hero-6" className="hero-section division"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {SLIDES.map((s, i) => (
        <div
          key={i}
          className={`hero-slide${i === current ? ' active' : ''}`}
          style={{ backgroundImage: `url('${s.img}')` }}
        />
      ))}
      <div className="hero-overlay hero-align-left">
        <h1>{slide.heading}</h1>
        <h3>{slide.sub}</h3>
        <a href="#standard" className="hero-cta-btn" onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (window.innerWidth <= 768) {
            window.location.href = '/products';
          } else {
            const el = document.getElementById('standard');
            if (el) {
              const headerH = document.getElementById('header')?.offsetHeight || 90;
              window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - headerH, behavior: 'smooth' });
            }
          }
        }}>View Product Range</a>
      </div>
      <div className="hero-dots">
        {SLIDES.map((_, i) => (
          <span
            key={i}
            className={`hero-dot${i === current ? ' active' : ''}`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </section>
  );
}

export default HeroSection;
